const PREFERRED_ERROR_KEYS = ["detail", "message", "error"];
const ERROR_METADATA_KEYS = new Set(["code", "status", "trace_id", "request_id"]);

export const extractErrorDetail = (value, depth = 0) => {
  if (depth > 5 || value === null || value === undefined) return "";
  if (typeof value === "string") return value.trim();
  if (Array.isArray(value)) {
    for (const item of value) {
      const detail = extractErrorDetail(item, depth + 1);
      if (detail) return detail;
    }
    return "";
  }
  if (typeof value !== "object") return "";

  for (const key of PREFERRED_ERROR_KEYS) {
    const detail = extractErrorDetail(value[key], depth + 1);
    if (detail) return detail;
  }
  for (const [key, item] of Object.entries(value)) {
    if (PREFERRED_ERROR_KEYS.includes(key) || ERROR_METADATA_KEYS.has(key)) continue;
    const detail = extractErrorDetail(item, depth + 1);
    if (detail) return detail;
  }
  return "";
};

export const readErrorDetail = async (response) => {
  try {
    const raw = await response.text();
    const text = raw.trim();
    if (!text) return "";
    try {
      return extractErrorDetail(JSON.parse(text));
    } catch (error) {
      // Preserve a useful plain-text server message, but ignore a lone field
      // token produced by older broken SSE renderers.
      if (/^[A-Za-z_][A-Za-z0-9_]*$/.test(text) || text.includes("<")) return "";
      return text.slice(0, 500);
    }
  } catch (error) {
    return "";
  }
};
